import { useShallowEqualSelector } from '../../utils/reduxUtils';
import { Loadable } from '@card/types';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { CredentialsActions } from './actions';

export function useProblemCredentialsCount(): Loadable<number> {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(CredentialsActions.fetchBlockedCountStarted());
  }, [dispatch]);

  return useShallowEqualSelector((state) => state.credentials.problemCredentialsCount);
}
